// export { default } from 'src/components/carousel/LandingCarouseltry';
export { default } from './Services';